<template>
  <div id="app">
    <span
      :class="isOwnerAccount ? 'admin-mode' :'instructor-mode'"
    />
    <restrict-announce-screen />
    <div
      v-show="
        showIEWarning"
      class="ieInfo"
    >
      현재 브라우저에서는 피플박스의 일부 기능을 이용하실 수 없습니다. <a href="https://www.google.co.kr/chrome/index.html">
        Chrome
      </a>을 다운 받아주시길 바랍니다.
    </div>

    <router-view />
  </div>
</template>
<script>
import { bootIntercom } from './utils/third-party-app';
import { fiflboxApi } from '@/utils/api';
import { computedGetters } from '@/utils/vuex-helper';
import RestrictAnnounceScreen from './components/RestrictAnnounceScreen.vue';

function ifIE() {
  let agent = navigator.userAgent.toLowerCase();

  if (
    (navigator.appName == 'Netscape' &&
      navigator.userAgent.search('Trident') != -1) ||
    agent.indexOf('msie') != -1
  ) {
    return true;
  }
  return false;
}

export default {
  components: { RestrictAnnounceScreen },
  data() {
    return {
      showIEWarning: false,
      isInitialRender: true
    };
  },
  computed: {
    ...computedGetters(['role', 'isOwnerAccount', 'instructorDefaultPage'])
  },
  watch: {
    $route: {
      immediate: true,
      async handler(to, from) {
        if (to.meta.title) {
          document.title = '피플박스 | ' + to.meta.title;
        } else {
          document.title = '피플박스';
        }
        this.accessBlockBasicHandler(to.path);
      }
    }
  },
  async created() {
    this.showIEWarning = ifIE();
    if (this.$tokenStorage.hasToken()) {
      const bearerToken = this.$tokenStorage.getBearerToken();
      fiflboxApi.default.setHeadersAuthorization(bearerToken);
      // 1. set role
      await this.$store.commit('setIsOwnerAccount', this.role);
      // 2. when role is instructor, set instructors basic auth to store.(access-auth, defaltpage..)
      if (!this.isOwnerAccount) {
        await this.setInstructorModeBasicInfo();
      }
    }
    bootIntercom();
  },
  methods: {
    async setInstructorModeBasicInfo() {
      await this.$store.dispatch('syncInstructorAccessAuthByToken');
      await this.$store.dispatch('syncInstructorDefaultPage');
      await this.$store.dispatch('syncAccountAccessAuth');
    },
    async accessBlockBasicHandler(path) {
      let isAccessAllowed = true;
      switch (path) {
        case '/payment':
        case '/account':
        case '/setting/instructor':
        case '/referral':
          isAccessAllowed = this.isOwnerAccount;
          break;
        default:
          isAccessAllowed = true;
          break;
      }
      if (!isAccessAllowed) {
        this.$router.push('/announce/access-block').catch(() => {});
      }
    }
  }
};
</script>
<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  letter-spacing: -0.8px;
  font-family: Roboto, Noto Sans Korean;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  // -webkit-overflow-scrolling: touch;
  height: 100%;
  touch-action: manipulation !important;
  overflow-x: hidden;
}

#app {
  height: 100%;
}

h1 {
  margin: 0;
}

input,
button,
textarea,
select {
  -webkit-transform: translate3d(0, 0, 0);
}

.intercom-namespace .intercom-app {
  transition: opacity 0.6s ease;
  opacity: 1;

  iframe {
    z-index: 999;
  }

  &.hide {
    opacity: 0;
  }
}

.ieInfo {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 36px;
  line-height: 36px;
  background: #d8d8d8;
  text-align: center;
  color: #272727;
}
.ieInfo a {
  text-decoration: underline;
}

.el-table-filter {
  @media screen and (max-width: 768px) {
    max-width: 97.3%;
  }
}

.announce-bar {
  order: 1;
  flex: initial;
  height: 45px;
  width: 100%;
  background-color: #4a4a4a;

  font-size: 15px;
  text-align: center;
  color: #ffffff;
  letter-spacing: -0.8px;
  line-height: 45px;
  position: relative;
  cursor: pointer;

  .ic-guidebar-close {
    position: absolute;
    top: 11px;
    right: 15px;
  }

  .button_buy-now {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -1.1px;
    text-align: center;
    color: #4a4a4a;

    padding: 0 9px;
    height: 31px;
    line-height: 31px;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    margin-left: 10px;

    text-decoration: none;
  }
  .link {
    color: #ffffff;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 5px;
  }

  &.mobile {
    height: 40px;
    line-height: 40px;
    font-size: 13px;

    .button_buy-now {
      padding: 0 7px;
      font-size: 12px;
    }
  }
}
@media screen and (max-width: 768px) {
  .el-popover.el-popper.fifl-popper {
    z-index: 3001 !important;
  }
  // .el-select-dropdown.el-popper{
  // 	z-index: 2017 !important;
  // }
  .el-message-box__wrapper {
    z-index: 9999 !important;
  }
}
</style>
